export default function offerReviewsOptionsResolver({ offer }) {
    return {
        bind: {
            offer,
        },
    };
}